// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__8vAc3","docList":"footer_docList__FT+Od","docItem":"footer_docItem__zIUqg","title":"footer_title__35UAd","footerCopyright":"footer_footerCopyright__TftEp"};